import { render, staticRenderFns } from "./NoticeBoardWidget.vue?vue&type=template&id=75da86ba&"
import script from "./NoticeBoardWidget.vue?vue&type=script&lang=js&"
export * from "./NoticeBoardWidget.vue?vue&type=script&lang=js&"
import style0 from "./NoticeBoardWidget.vue?vue&type=style&index=0&id=75da86ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports